const convertSorting = ({ field, isAsc }) => {
  if (!isAsc) return `-${field}`;

  return field;
};

export default convertSorting;
